// Campaign Create Flow
export const CAMPAIGN_CREATE_FLOW_SET_STEP = 'CAMPAIGN_CREATE_FLOW_SET_STEP';
export const CAMPAIGN_CREATE_FLOW_SET_BASE_RATE = 'CAMPAIGN_CREATE_FLOW_SET_BASE_RATE';
export const CAMPAIGN_CREATE_FLOW_SET_PROP = 'CAMPAIGN_CREATE_FLOW_SET_PROP';
export const CAMPAIGN_CREATE_FLOW_SET_UNSAVED_CHANGES = 'CAMPAIGN_CREATE_FLOW_SET_UNSAVED_CHANGES';
export const CAMPAIGN_CREATE_FLOW_CLEAR = 'CAMPAIGN_CREATE_FLOW_CLEAR';
export const CAMPAIGN_CREATE_FLOW_SET_ERRORS = 'CAMPAIGN_CREATE_FLOW_SET_ERRORS';
export const CAMPAIGN_CREATE_FLOW_CLEAR_ERROR = 'CAMPAIGN_CREATE_FLOW_CLEAR_ERROR';
export const CAMPAIGN_CREATE_FLOW_CLEAR_ERRORS = 'CAMPAIGN_CREATE_FLOW_CLEAR_ERRORS';

// Users Step
export const CAMPAIGN_CREATE_FLOW_ADD_USER = 'CAMPAIGN_CREATE_FLOW_ADD_USER';
export const CAMPAIGN_CREATE_FLOW_ADD_USERS = 'CAMPAIGN_CREATE_FLOW_ADD_USERS';
export const CAMPAIGN_CREATE_FLOW_REMOVE_USER = 'CAMPAIGN_CREATE_FLOW_REMOVE_USER';
export const CAMPAIGN_CREATE_FLOW_REMOVE_ALL_USERS = 'CAMPAIGN_CREATE_FLOW_REMOVE_ALL_USERS';


// Incentives Step
export const CAMPAIGN_CREATE_FLOW_SET_INCENTIVE_TYPE = 'CAMPAIGN_CREATE_FLOW_SET_INCENTIVE_TYPE';
export const CAMPAIGN_CREATE_FLOW_SET_LINKS_INCENTIVE = 'CAMPAIGN_CREATE_FLOW_SET_LINKS_INCENTIVE';
export const CAMPAIGN_CREATE_FLOW_SET_BOOST_COMMISSION_INCENTIVE = 'CAMPAIGN_CREATE_FLOW_SET_BOOST_COMMISSION_INCENTIVE';
export const CAMPAIGN_CREATE_FLOW_SET_GMV_INCENTIVE = 'CAMPAIGN_CREATE_FLOW_SET_GMV_INCENTIVE';
